import { useState } from "react"
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";
import { MyModalContentDateInput } from "../StyleSheets/ModalStyle";

import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function AbschnittUpdate({ rowEntry, reloadData, absInstance }) {

    const [showModal, setShowModal] = useState(false);
    const [update, setUpdate] = useState(new MonitorApi.AbschnittUpdate());
    const [upAvailable, setUpAvailable] = useState(false);
    const [myComment, setMyComment] = useState('');


    const formatDate = ddmmyyyy => {
        console.log("datum: ", ddmmyyyy)
        if (ddmmyyyy === null) {
            return null;
        }
        const arr = ddmmyyyy.split('.');
        var date = '';
        date = date.concat(arr[2], '-');
        if (arr[1].length < 2) {
            date = date.concat('0', arr[1], '-');
        } else {
            date = date.concat(arr[1], '-');
        }
        if (arr[0].length < 2) {
            date = date.concat('0', arr[0]);
        } else {
            date = date.concat(arr[0]);
        }
        return date
    }

    const [inputs, setInputs] = useState({});

    const openModal = event => {
        setMyComment(rowEntry.original.kommentar);
        setInputs({
            von: rowEntry.original.bhfbeginn,
            bis: rowEntry.original.bhfende,
            gueltigVon: formatDate(rowEntry.original.gueltigVon),
            gueltigBis: formatDate(rowEntry.original.gueltigBis),
            kommentar: rowEntry.original.kommentar
        });
        setUpdate(pre => ({ ...pre, "absId": rowEntry.original.id }))
        setShowModal(true);
        setUpAvailable(false);

    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const closeModal = () => {
        setUpdate({});
        setShowModal(false);
    }

    const changeUpdate = event => {
        setUpAvailable(true);
        setUpdate(pre => ({ ...pre, [event.target.id]: event.target.value }));

        if (event.target.id === 'kommentar') {
            setMyComment(event.target.value);
        }
    }

    const saveChanges = event => {
        event.preventDefault();
        let result = new Promise((resolve) =>
            absInstance.updateAbschnitt(update, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            }))

        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <h3>Änderungen eintragen:</h3>
                    <p>(Für Abschnitt zwischen {inputs.von} und {inputs.bis})</p>
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn: ({inputs.gueltigVon})
                            <MyModalContentDateInput id="gueltigVon"
                                onChange={changeUpdate}
                                value={update.gueltigVon ? update.gueltigVon : inputs.gueltigVon} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Gültigkeitsende: {inputs.gueltigBis ? `(${inputs.gueltigBis})` : ""}
                            <MyModalContentDateInput id="gueltigBis"
                                onChange={changeUpdate}
                                value={update.gueltigBis ? update.gueltigBis : inputs.gueltigBis} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput id="kommentar"
                                onChange={changeUpdate}
                                value={myComment} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbrechen</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>
    )
}